import * as types from "./mutation-types";

export default {
  [types.SET_CONFIGURACOES](state, payload) {
    state.configuracoes = payload;
  },
  [types.SET_ISLOADING](state, payload) {
    state.is_loading = payload;
  },
};
